import React from 'react';

import styles from './Button.module.scss';

const buttonSizeClasses = {
  small: styles.small,
  medium: styles.medium,
  large: styles.large,
  xlarge: styles.xlarge,
  auto: styles['width-auto'],
};

const Button = ({ type, size, children, ...rest }) => {
  const classes = [styles.button];
  if (type === 'primary') {
    classes.push(styles.primary);
  }

  if (type === 'secondary') {
    classes.push(styles.secondary);
  }

  if (buttonSizeClasses[size]) {
    classes.push(buttonSizeClasses[size]);
  }

  return (
    <div>
      <button className={classes.join(' ')} {...rest}>
        {children}
      </button>
    </div>
  );
};

export default Button;
